<script setup lang="ts">
import type { ColorVariant, ContentConversation, PersonId } from '~/models/Content/ContentConversation'
import { computed, provide } from 'vue'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'

const { item } = defineProps<{ item: ContentConversation }>()

const isTwoPersonDialog = computed(() => item.persons.length === 2)

let itemIndex = 0

function getPersonColorVariant(personId: PersonId): ColorVariant {
  if (!isTwoPersonDialog.value) {
    return 'current'
  }
  const index = item.persons.findIndex(person => person.id === personId)
  return index === 0 ? 'pop' : 'current'
}

function getNextItemIndex(): number {
  return itemIndex++
}

provide<ContentConversation | undefined>('conversation', item)
provide<(personId: PersonId) => ColorVariant>('getPersonColorVariant', getPersonColorVariant)
provide<() => number>('getNextItemIndex', getNextItemIndex)
</script>

<template>
  <RichTextRenderer
    v-if="item.body"
    :text="item.body"
  />
</template>
